import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Dashboard from './pages/dashboard/dashboard';
import Login from './pages/login/login';



export default function Router() {

        const routes = useRoutes([
            { path: '/', element: <Navigate to="/app" replace /> },
            { path: '/login', element: <Login /> },    
            { path: '/dashboard', element: <Dashboard /> },    
            { path: '/app', element: <Login /> },  

        ])


    // const routes = useRoutes([
    //     {
    //       path: '/',
    //       element: !isAuthenticated ? <Navigate to="/login" replace /> : <DashboardLayout />,
    //       children: [
    //         { element: <Navigate to="/app" />, index: true },
    //         { path: 'app', element: <DashboardAppPage /> },
    //         { path: 'customer/customer-list', element: <CustomerList /> },
    //         { path: 'customer/create', element: <CustomerCreate /> },
    //         { path: 'customer/edit', element: <CustomerEdit /> },
    //         { path: 'expedisi/expedisi-list', element: <ExpedisiList /> },
    //         { path: 'expedisi/create', element: <ExpedisiCreate /> },
    //         { path: 'expedisi/edit', element: <ExpedisiEdit /> },
    //         { path: 'vendor/vendor-list', element: <VendorList /> },
    //         { path: 'vendor/create', element: <VendorCreate /> },
    //         { path: 'vendor/edit', element: <VendorEdit /> },
    //         { path: 'oem', element: <OEMList /> },
    //         { path: 'blog', element: <BlogPage /> },
    //         { path: 'periode/periode-list', element: <PeriodeList /> },
    //         { path: 'periode/edit', element: <PeriodeEdit /> },
    //         { path: 'product', element: <ProductList /> },
    //         { path: 'visitreport/visitreport-list', element: <VisitReportList /> },
    //       ],
    //     },
    //     {
    //       path: 'login',
    //       element: <LoginPage />,
    //     },
    //     { path: 'onboarding', element: <OnBoarding /> },
    //     {
    //       element: <SimpleLayout />,
    //       children: [
    //         { element: <Navigate to="/" />, index: true },
    //         { path: '404', element: <Page404 /> },
    //         { path: '*', element: <Navigate to="/404" /> },
    //       ],
    //     },
    //     {
    //       path: '*',
    //       element: <Navigate to="/404" replace />,
    //     },
    //   ]);
    
       return routes;



}
